import { render, staticRenderFns } from "./RoutesDashboard.vue?vue&type=template&id=898adb8a&scoped=true&"
import script from "./RoutesDashboard.vue?vue&type=script&lang=js&"
export * from "./RoutesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898adb8a",
  null
  
)

export default component.exports